import React from 'react';
import { Handle, Position } from '@xyflow/react';
import type { NodeProps } from '@xyflow/react';
import { Card, Typography, IconButton, Stack } from '@mui/joy';
import { PencilSimple as EditIcon, Flag as FlagIcon, Trash as DeleteIcon } from '@phosphor-icons/react';
import type { AutomationTrigger } from '../../../types/automations';

interface TriggerNodeData {
  trigger: AutomationTrigger;
  onEdit: () => void;
  onDelete: () => void;
}

export default function TriggerNode({ data }: NodeProps) {
  const trigger = (data as unknown as TriggerNodeData).trigger;
  const onEdit = (data as unknown as TriggerNodeData).onEdit;
  const onDelete = (data as unknown as TriggerNodeData).onDelete;

  const getTriggerLabel = (type: string) => {
    const labels: Record<string, string> = {
      new_contact_added: 'New Contact Added',
      opportunity_tag: 'Opportunity Tag',
      job_tag: 'Job Tag',
      contact_tag: 'Contact Tag',
      task_added: 'Task Added',
      task_completed: 'Task Completed',
      form_submitted: 'Form Submitted',
      payment_received: 'Payment Received',
      payment_overdue: 'Payment Overdue',
      opportunity_won: 'Opportunity Won',
      job_complete: 'Job Complete',
      estimate_requested: 'Estimate Requested',
      weather_report_generated: 'Weather Report Generated',
      opportunity_stage_changed: 'Opportunity Stage Changed',
      opportunity_stage_stalled: 'Opportunity Stage Stalled',
      job_stage_changed: 'Job Stage Changed',
      job_stage_stalled: 'Job Stage Stalled',
    };
    return labels[type] || type;
  };

  return (
    <>
      <Handle type="source" position={Position.Bottom} />
      <Card
        variant="outlined"
        sx={{
          minWidth: 250,
          bgcolor: 'success.softBg',
          borderColor: 'success.500',
          borderWidth: 2,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <FlagIcon color="var(--joy-palette-success-500)" />
          <Typography level="title-md" sx={{ flex: 1 }}>
            Trigger: {getTriggerLabel(trigger.trigger_type)}
          </Typography>
          <IconButton size="sm" onClick={onEdit}>
            <EditIcon size={18} />
          </IconButton>
          <IconButton size="sm" color="danger" onClick={onDelete}>
            <DeleteIcon size={18} />
          </IconButton>
        </Stack>
        {trigger.config && Object.keys(trigger.config).length > 0 && (
          <Typography level="body-sm" sx={{ mt: 1 }}>
            {trigger.trigger_type === 'form_submitted' && trigger.config.form_ids?.length > 0
              ? `${trigger.config.form_ids.length} form${trigger.config.form_ids.length > 1 ? 's' : ''} selected`
              : 'Configured'}
          </Typography>
        )}
      </Card>
    </>
  );
}
